// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorScreen } from 'common/components/core/errors';

const AccessDeniedScreen = (): React.Node => {
    const { t } = useTranslation();

    return (
        <ErrorScreen
            errorCodeText="403"
            title={t('translations:accessDenied.page.title')}
            subtitle={t('translation:accessDenied.page.subtitle')}
        />
    );
};

export default AccessDeniedScreen;
